import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
    appName: 'Hartford HealthCare Benefits',
    frontend: 'https://hhccares4me.com',
    apiHash: 'https://hhccares4me.com/api/1.0',
    api: '/api/2.0',
    trustModel: false,
    authHeaders: {
        xServiceProvider: 'hhc-prod-frontend',
        'tenant-id': '677b1479-071a-4575-96d5-ff1a7b3c586a',
        'consumer-id': '07a80c53-a764-4217-8966-0fef28c670b0',
    },
    commitSHA: '1664030',
    provider: 'hhc-prod-frontend',
    gtm: 'GTM-N6TB7JNN',
    cookiePolicy: '64141e6f',
    multilingual: true,
    colors: {
        primary: '#0098c3',
        secondary: '#a40084',
        actionBg: '#a40084',
        headingText: '#323436',
        calloutHeadingText: '#323436',
        linkText: '#a40084',
        footerTopBorder: '#a40084',
    },
    typography: {
        actionFontWeight: '700',
        headingColorStrategy: 'h1-only',
        font: {
            heading: {
                family: 'caecilia',
                url: 'https://use.typekit.net/anv8akt.css',
            },
            body: {
                family: 'Inter',
                url: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
            },
        },
    },
    blocks: {
        quickLinksStyle: 'rounded',
    },
    footer: {
        style: 'divided',
    },
    readabilityEnabled: false,
    articlesParentRoute: 'news',
    imagery: {
        logo: 'https://storage.googleapis.com/archipelago-assets/hartford-healthcare/logo-desktop.svg',
        logoInverted: 'https://storage.googleapis.com/archipelago-assets/hartford-healthcare/logo-desktop.svg',
        logoTransparent: 'https://storage.googleapis.com/archipelago-assets/hartford-healthcare/logo-desktop.svg',
        logoMobile: 'https://storage.googleapis.com/archipelago-assets/hartford-healthcare/logo-mobile.svg',
        favicon: 'https://storage.googleapis.com/archipelago-assets/favicons/hhc-favicon.ico'
    },
    copyright: '&copy; ' + new Date().getFullYear() + ' Gallagher. All Rights Reserved.' + ' Powered by Core.',
    demoMode: false,
    chatEnabled: false,
    contactEnabled: false,
    isDarkModeEnabled: false,
    postsLabel: 'news',
    coreLinkify: true,
    navigation: {
        navType: 'top',
        headerStyle: 'solid',
        style: 'default',
        categoryNav: false,
        navigationOrder: 'displayOrder',
        navbarBrandWidth: '250px',
    },
    pwa: {
        enabled: false,
        notifications: false,
    },
    enableSSR: false,
    faqsEnabled: false,
    benefitPIDS: [25],
    miscPIDS: [3],
} as CONFIG;
